import React from 'react';

const ReplaceIcon = props => (
  <svg viewBox="0 0 16 16" {...props}>
    <g strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-287.000000, -17.000000)" fillRule="nonzero">
        <path d="M297.001716,27.8755353 L300.2505,27.9165001 C299.047537,29.7652943 296.989183,30.8808798 294.780812,30.8809592 C291.601676,30.757293 289.073179,28.1756705 289.020875,25 L288.020017,25 C287.969133,26.8169762 288.660573,28.5764937 289.935462,29.8742619 C291.210352,31.1720301 292.959071,31.8964618 294.779811,31.8811019 C297.240026,31.8303657 299.537439,30.6430278 300.999142,28.666857 L300.999142,32 L302,32 L302,27.004282 L297.001716,27.004282 L297.001716,27.8755353 L297.001716,27.8755353 Z M292.998284,22.1254639 L289.757506,22.0834999 C290.962274,20.2346294 293.02178,19.1192355 295.231198,19.1190408 C298.410808,19.2431088 300.940233,21.8238856 300.995139,25 L301.995997,25 C302.044674,23.1823602 301.351379,21.4230028 300.075202,20.1256502 C298.799026,18.8282975 297.049538,18.1043371 295.228196,18.1198972 C292.76607,18.1718065 290.466702,19.358627 289.000858,21.3341422 L289.000858,18 L288,18 L288,22.995718 L292.998284,22.995718 L292.998284,22.1204682 L292.998284,22.1254639 Z"/>
      </g>
    </g>
  </svg>
);

export default ReplaceIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/replace-icon.js